/**
 * Created by lenovo on 2017/3/24.
 */
import xhr from './../xhr/'

import { ellaUrl,micaUrl } from '../../path.config'
import  {getProductId} from 'UTIL/common'
const productId = getProductId();
class normalUserService {
    //普通用户列表
    normalUserList({data}={}){
        return xhr({
            method: 'post',
            url: ellaUrl+'/lease/normalUser/page',
            body : data
        })
    }
    //普通用户禁用
    normalUserDisable(id){
        return xhr({
            method : 'get',
            url :ellaUrl+"/user/disable/"+id
        })
    }
    //普通用户启用
    normalUserEnable(id){
        return xhr({
            method : 'get',
            url :ellaUrl+"/user/enable/"+id
        })
    }
    normalUserDetail(id){
        return xhr({
            method : 'get',
            url : ellaUrl+"/lease/normalUser/detail/"+id,
        })
    }
    //冻结资金账户
    normalUserFreeze(id){
        return xhr({
            method:'get',
            url:micaUrl+"/account/freeze?productId="+productId+"&userId="+id,
        })
    }
    normalUserAbnormal(id){
        return xhr({
            method:'get',
            url:micaUrl+"/account/abnormal?productId="+productId+"&userId="+id,
        })
    }

}

// 实例化后再导出
export default new normalUserService()


// WEBPACK FOOTER //
// ./modules/services/ella/normalUserService.js